// extracted by mini-css-extract-plugin
module.exports = {"opcao":"Opcao_opcao__FyQe9","descricao":"Opcao_descricao__klezR","minificado":"Opcao_minificado__376cv","botaoMinimizado":"Opcao_botaoMinimizado__1FTI5"};